//--------------- IMPORTAÇÃO DO REACT ROUTER DOM ---------------//
import { lazy, Suspense } from "react";
import {
  Routes, // Importação do Routes para poder usar o Route
  Route, // Importação do Route para poder trabalhar com rotas
  useLocation // Importação do useLocation para poder saber em qual rota o usuário está
} from "react-router-dom";



//--------------- IMPORTAÇÃO DAS PÁGINAS ---------------//
import {
  Login, // Importação da Página de Login
  Dashboard, // Importação da Página de Dashboard
  Webhook, // Importação da Página de Webhooks
  Empresas, // Importação da Página de gerenciamento de Empresas
  Usuarios, // Importação da Página de gerenciamento de Usuários
  Produtos, // Importação da Página de gerenciamento de Produtos
  Tags, // Importação da Página de gerenciamento de Tags
  Leads, // Importação da Página de gerenciamento de Leads
  Orderbumps, // Importação da Página de Relatório de Orderbump
  Grupos, // Importação da Página de Grupos
  Gastos, // Importação da Página de Gastos do Grupo
  Trafego, // Importação da Página de Relatório de Grupo
  Tracking, // Importação da Página de Relatório de Tracking
  Vendas, // Importação da Página de Vendas
  Integracoes, // Importação da Página de Integrações
  RelatorioProdutos, // Importação da Página de Relatório de Produtos
  Dominios,
} from "./features";

const AnaliseComparativa = lazy(() => import("./features/AnaliseComparativa/AnaliseComparativa"));
const AutomacaoEditor = lazy(() => import("./features/Automacoes/AutomacaoEditor"));
import AutomacoesList from "./features/Automacoes/AutomacoesList";

//--------------- IMPORTAÇÃO DAS PÁGINAS DE AGENTES ---------------//
const AgenteEditor = lazy(() => import("./features/Agentes/AgenteEditor"));
import AgentesList from "./features/Agentes/AgentesList";

//--------------- IMPORTAÇÃO DA PÁGINA CONFIG IA (Fase 2) ---------------//
const ConfigIA = lazy(() => import("./features/ConfigIA/ConfigIA"));

//--------------- IMPORTAÇÃO DA PÁGINA BOT DE AVISOS ---------------//
const BotAvisos = lazy(() => import("./features/BotAvisos/BotAvisos"));
const RespostasRapidas = lazy(() => import("./features/RespostasRapidas/RespostasRapidas"));



//--------------- IMPORTAÇÃO DA PÁGINA WHATSAPP SESSÕES ---------------//
import WhatsAppSessoes from "./features/WhatsAppSessoes/WhatsAppSessoes";
import { WhatsAppSessoesProvider } from "./features/WhatsAppSessoes/context/WhatsAppSessoesContext";

//--------------- IMPORTAÇÃO DA PÁGINA WHATSAPP OFICIAL (Meta Cloud API) ---------------//
import WhatsappOficial from "./features/WhatsappOficial/WhatsappOficial";

//--------------- IMPORTAÇÃO DA PÁGINA INSTAGRAM (Meta Graph API) ---------------//
import InstagramOficial from "./features/Instagram/InstagramOficial";
import InstagramInbox from "./features/Instagram/InstagramInbox";
import AdsContas from "./features/Ads/pages/AdsContas";
import AdsDashboards from "./features/Ads/pages/AdsDashboards";
import AdsProduto from "./features/Ads/pages/AdsProduto";
import AdsDashboard from "./features/Ads/pages/AdsDashboard";

//--------------- IMPORTAÇÃO DA PÁGINA CHAT (top-level inbox Meta) ---------------//
import Chat from "./features/Chat/Chat";

//--------------- IMPORTAÇÃO DO CHAT POR SESSÃO (wppconnect, não-oficial) ---------------//
import WhatsAppChat from "./features/WhatsAppChat/WhatsAppChat";

//--------------- IMPORTAÇÃO DA PÁGINA RELATÓRIOS WHATSAPP ---------------//
import WhatsappRelatorios from "./features/WhatsappRelatorios/WhatsappRelatorios";

//--------------- IMPORTAÇÃO DAS PÁGINAS WHATSAPP CAMPANHAS ---------------//
import WhatsAppCampanhas from "./features/WhatsAppCampanhas/WhatsAppCampanhas";
import WhatsAppCampanhaDetalhe from "./features/WhatsAppCampanhas/WhatsAppCampanhaDetalhe";
import WhatsAppDashboardFila from "./features/WhatsAppCampanhas/WhatsAppDashboardFila";
import GrupoRedirect from "./features/WhatsAppCampanhas/GrupoRedirect";



//--------------- IMPORTAÇÃO DAS PÁGINAS DE FLUXO ---------------//
import {
  Fluxos, // Importação da Página de Fluxos
  FluxoCriacao // Importação da Página de Fluxos de Criação
} from "./features/fluxos"



//--------------- IMPORTAÇÃO DE COMPONENTES ---------------//
import {
  Sidebar, // Importação do Componente Sidebar para a navegação entre as páginas pela barra lateral
  PrivateRoute // Importação do Componente PrivateRoute para a verificação de rotas privadas
} from "./shared/components"



import { EmpresasProvider } from "./features/Empresas/context/EmpresasContext";
import { DashboardProvider } from "./features/Dashboard/context/DashboardContext";
import { LoginProvider } from "./features/Login/context/LoginContext";
import { UsuariosProvider } from "./features/Usuarios/context/UsuariosContext";
import { LeadsProvider } from "./features/Leads/context/LeadsContext";
import LeadsQuentes from "./features/Leads/LeadsQuentes";
import { VendasProvider } from "./features/Vendas/context/VendasContext";
import { ProdutosProvider } from "./features/Produtos/context/ProdutosContext";
import { GruposProvider } from "./features/Grupos/context/GruposContext";
import { TagsProvider } from "./features/Tags/context/TagsContext";
import { GastosProvider } from "./features/Gastos/context/GastosContext";
import { OrderbumpsProvider } from "./features/Orderbumps/context/OrderbumpsContext";
import { TrafegoProvider } from "./features/Trafego/context/TrafegoContext";
import { TrackingProvider } from "./features/Tracking/context/TrackingContext";
import { IntegracoesProvider } from "./features/Integracoes/context/IntegracoesContext";
import { RelatorioProdutosProvider } from "./features/RelatorioProdutos/context/RelatorioProdutosContext";
import { AnaliseComparativaProvider } from "./features/AnaliseComparativa/context/AnaliseComparativaContext";

import { SidebarProvider } from "./shared/context/SidebarContext";
import { PrivateRouteProvider } from "./shared/components/PrivateRoute/context/PrivateRouteContext";

import FunilConversao from "./features/Tracking/pages/FunilConversao";
import CheckoutLeads from "./features/Tracking/pages/CheckoutLeads";
import VideoAnalytics from "./features/Tracking/pages/VideoAnalytics";
import JornadaCliente from "./features/Tracking/pages/JornadaCliente";
import TrackingConfig from "./features/Tracking/pages/TrackingConfig";
import VendasSemTracking from "./features/Tracking/pages/VendasSemTracking";
import Documentacao from "./features/Documentacao/pages/Documentacao";
import Visitantes from "./features/Tracking/pages/Visitantes";



//--------------- EXPORTAÇÃO DO APP ROUTES ---------------//
export default function AppRoutes() {

  //--------------- CRIAÇÃO DE HOOKS ---------------//
  const location = useLocation(); // Localição que armazena a rota em que o usuário está


  //--------------- CRIAÇÃO DE VARIÁVEIS ---------------//
  const hideSidebar = location.pathname === '/login' || location.pathname === '/fluxos/criar' || location.pathname.startsWith('/g/') || location.pathname.includes('/editar');


  //--------------- RETORNO DO APP ROUTES ---------------//
  return (
    <>

      {/* SIDEBAR */}
      {!hideSidebar && <SidebarProvider><Sidebar /></SidebarProvider>}


      {/* ROUTES */}
      <Routes>

        {/* ROTAS ESTRUTURADAS */}
        <Route path="/login" element={<LoginProvider>           <Login />         </LoginProvider>} />
        <Route path="/" element={<PrivateRouteProvider>    <PrivateRoute>    <DashboardProvider>     <Dashboard />     </DashboardProvider>    </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/empresas" element={<PrivateRouteProvider>    <PrivateRoute>    <EmpresasProvider>      <Empresas />      </EmpresasProvider>     </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/usuarios" element={<PrivateRouteProvider>    <PrivateRoute>    <UsuariosProvider>      <Usuarios />      </UsuariosProvider>     </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/vendas" element={<PrivateRouteProvider>    <PrivateRoute>    <VendasProvider>        <Vendas />        </VendasProvider>       </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/produtos" element={<PrivateRouteProvider>    <PrivateRoute>    <ProdutosProvider>      <Produtos />      </ProdutosProvider>     </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/grupos" element={<PrivateRouteProvider>    <PrivateRoute>    <GruposProvider>        <Grupos />        </GruposProvider>       </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/tags" element={<PrivateRouteProvider>    <PrivateRoute>    <TagsProvider>          <Tags />          </TagsProvider>         </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/leads" element={<PrivateRouteProvider>    <PrivateRoute>    <LeadsProvider>         <Leads />         </LeadsProvider>        </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/leads/quentes" element={<PrivateRouteProvider>    <PrivateRoute>    <LeadsQuentes />    </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/relatorios/orderbumps" element={<PrivateRouteProvider>    <PrivateRoute>    <OrderbumpsProvider>    <Orderbumps />    </OrderbumpsProvider>   </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/gastos" element={<PrivateRouteProvider>    <PrivateRoute>    <GastosProvider>        <Gastos />        </GastosProvider>       </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/relatorio-grupo" element={<PrivateRouteProvider>    <PrivateRoute>    <TrafegoProvider>       <Trafego />       </TrafegoProvider>      </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/tracking-relatorio" element={<PrivateRouteProvider>    <PrivateRoute>    <TrackingProvider>      <Tracking />      </TrackingProvider>     </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/integracoes" element={<PrivateRouteProvider>    <PrivateRoute>    <IntegracoesProvider>    <Integracoes />   </IntegracoesProvider>   </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/relatorio-produtos" element={<PrivateRouteProvider>    <PrivateRoute>    <RelatorioProdutosProvider> <RelatorioProdutos /> </RelatorioProdutosProvider>  </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/analise-comparativa" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><AnaliseComparativaProvider><Suspense fallback={<div className="min-h-screen bg-surface-1 flex items-center justify-center text-white">Carregando...</div>}><AnaliseComparativa /></Suspense></AnaliseComparativaProvider></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />

        {/* ROTAS QUE AINDA FALTAM ESTRUTURAR */}
        <Route path="/integracoes/webhook" element={<PrivateRouteProvider>    <PrivateRoute>    <Webhook />             </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/whatsapp/sessoes" element={<PrivateRouteProvider>    <PrivateRoute>    <WhatsAppSessoesProvider>  <WhatsAppSessoes />  </WhatsAppSessoesProvider> </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/whatsapp/oficial" element={<PrivateRouteProvider>    <PrivateRoute>    <WhatsappOficial />    </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/instagram/oficial" element={<PrivateRouteProvider>    <PrivateRoute>    <InstagramOficial />    </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/instagram/inbox" element={<PrivateRouteProvider>    <PrivateRoute>    <InstagramInbox />    </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/chat" element={<PrivateRouteProvider><PrivateRoute><Chat /></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/whatsapp/chat" element={<PrivateRouteProvider><PrivateRoute><WhatsAppChat /></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/whatsapp/chat/:sessaoId" element={<PrivateRouteProvider><PrivateRoute><WhatsAppChat /></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/whatsapp/relatorios" element={<PrivateRouteProvider><PrivateRoute><WhatsappRelatorios /></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/whatsapp/campanhas" element={<PrivateRouteProvider>    <PrivateRoute>    <WhatsAppCampanhas />    </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/whatsapp/campanhas/:id" element={<PrivateRouteProvider>    <PrivateRoute>    <WhatsAppCampanhaDetalhe />    </PrivateRoute>   </PrivateRouteProvider>} />
        <Route path="/whatsapp/fila" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><WhatsAppDashboardFila /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/fluxos/criar" element={<FluxoCriacao />} />
        <Route path="/fluxos" element={<Fluxos />} />
        <Route path="/dominios" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><Dominios /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />

        {/* AUTOMAÇÕES DE LEADS */}
        <Route path="/automacoes" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><AutomacoesList /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/automacoes/:id/editar" element={<PrivateRouteProvider><PrivateRoute><Suspense fallback={<div className="min-h-screen bg-surface-1 flex items-center justify-center text-white">Carregando editor...</div>}><AutomacaoEditor /></Suspense></PrivateRoute></PrivateRouteProvider>} />

        {/* AGENTES (BOTS DE WHATSAPP) */}
        <Route path="/agentes" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><AgentesList /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/agentes/:id/editar" element={<PrivateRouteProvider><PrivateRoute><Suspense fallback={<div className="min-h-screen bg-surface-1 flex items-center justify-center text-white">Carregando editor...</div>}><AgenteEditor /></Suspense></PrivateRoute></PrivateRouteProvider>} />

        {/* CONFIG IA (Fase 2) */}
        <Route path="/configuracoes/ia" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><Suspense fallback={<div className="min-h-screen bg-base flex items-center justify-center text-white">Carregando...</div>}><ConfigIA /></Suspense></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/whatsapp/bot-avisos" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><Suspense fallback={<div className="min-h-screen bg-base flex items-center justify-center text-white">Carregando...</div>}><BotAvisos /></Suspense></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/whatsapp/respostas-rapidas" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><Suspense fallback={<div className="min-h-screen bg-base flex items-center justify-center text-white">Carregando...</div>}><RespostasRapidas /></Suspense></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />

        {/* ROTA PÚBLICA - Redirect de grupo WhatsApp */}
        <Route path="/g/:slug" element={<GrupoRedirect />} />

        {/* TRACKING V2 PAGES */}
        <Route path="/tracking/funil" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><FunilConversao /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/tracking/leads" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><CheckoutLeads /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/tracking/videos" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><VideoAnalytics /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/tracking/jornada/:visitorId" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><JornadaCliente /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/tracking/config" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><TrackingConfig /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/tracking/vendas-sem-tracking" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><VendasSemTracking /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/ads/dashboards" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><AdsDashboards /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/ads/dashboards/:id" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><AdsDashboard /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/ads/produto" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><AdsProduto /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/ads/contas" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><AdsContas /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/tracking/visitantes" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><Visitantes /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/documentacao" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><Documentacao /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />
        <Route path="/documentacao/:slug" element={<PrivateRouteProvider><PrivateRoute><SidebarProvider><Documentacao /></SidebarProvider></PrivateRoute></PrivateRouteProvider>} />

      </Routes>



    </>
  );
}